import { Box, Slider, Typography } from '@mui/material';
import { SATURATION_MIN, SATURATION_MAX } from '../constants';

export interface SaturationControlsProps {
  saturation: number;
  onSaturationChange: (saturation: number) => void;
}

export const SaturationControls = ({
  saturation,
  onSaturationChange,
}: SaturationControlsProps) => {
  return (
    <Box>
      <Typography
        color="white"
        sx={{ display: { xs: 'none', md: 'block' }, mt: 1 }}
      >
        Saturation
      </Typography>

      <Slider
        value={saturation}
        onChange={(_, val) => onSaturationChange(val as number)}
        min={SATURATION_MIN}
        max={SATURATION_MAX}
        sx={{ color: 'white', width: 200 }}
      />
    </Box>
  );
};
